import PropTypes from 'prop-types';
import React from 'react';

class PaginationLink extends React.Component {
  static propTypes = {
    page: PropTypes.number.isRequired,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired
  };

  render() {
    const { page: _a, children: _b, ...otherProps } = this.props;

    return (
      <a {...otherProps} onClick={this._onClick}>
        {this.props.children}
      </a>
    );
  }

  _onClick = evt => {
    evt.preventDefault();
    this.props.onClick(this.props.page);
  };
}

export default PaginationLink;
